import api from './api';
import { 
  Job, 
  JobCreate, 
  JobUpdate, 
  JobSearchParams, 
  JobListParams,
  JobApplication,
  ApplicationCreate 
} from '@/types';

class JobService {
  async getJobs(params: JobListParams = {}): Promise<Job[]> {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, value.toString());
      }
    });
    
    const endpoint = queryParams.toString() ? `/api/jobs?${queryParams.toString()}` : '/api/jobs';
    const response = await api.get<Job[]>(endpoint);
    return response.data;
  }

  async searchJobs(params: JobSearchParams): Promise<Job[]> {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, value.toString());
      }
    });
    
    const response = await api.get<Job[]>(`/api/jobs/search?${queryParams.toString()}`);
    return response.data;
  }

  async getJob(id: number): Promise<Job> {
    const response = await api.get<Job>(`/api/jobs/${id}`);
    return response.data;
  }

  async createJob(jobData: JobCreate): Promise<Job> {
    const response = await api.post<Job>('/api/jobs', jobData);
    return response.data;
  }

  async updateJob(id: number, jobData: JobUpdate): Promise<Job> {
    const response = await api.put<Job>(`/api/jobs/${id}`, jobData);
    return response.data;
  }

  async deleteJob(id: number): Promise<void> {
    await api.delete(`/api/jobs/${id}`);
  }

  async applyToJob(jobId: number, applicationData: ApplicationCreate): Promise<JobApplication> {
    const response = await api.post<JobApplication>(`/api/jobs/${jobId}/apply`, applicationData);
    return response.data;
  }

  async getJobApplications(jobId: number): Promise<JobApplication[]> {
    const response = await api.get<JobApplication[]>(`/api/jobs/${jobId}/applications`);
    return response.data;
  }
}

export const jobService = new JobService();